export default {
    makhazinApi: 'https://makhazin.azurewebsites.net/api',
    lockTimeout: 30,
    lightTimeout: 900,
    routes: {
        booking: 'https://makhazin.se/pris/',
    },
};
